// @ts-ignore
import Dashboard from "./Dashboard";

// @ts-ignore
export const MyDashboard = () => {
  // return <Dashboard />;
  return <></>;
};
